import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { catchError, Observable, retry, throwError } from 'rxjs';
import { UsersService } from '../services/users/users.service';
import { UtilsService } from '../services/utils/utils.service';
import { Router } from '@angular/router';
import { APP_ROUTES } from '../common/app-routes';

@Injectable()
export class ErrorHandlingInterceptor implements HttpInterceptor {
  NETWORK_ERROR = 'No internet. Please check and try again.';
  UNKNOWN_ERROR = 'Unknown error!';
  constructor(
    private usersService: UsersService,
    private utilsService: UtilsService,
    private router: Router
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request)
      .pipe(
        retry(0),
        catchError((httpErrorResponse: HttpErrorResponse) => {
          console.log('error intercept', httpErrorResponse);
          let message = '';
          if (httpErrorResponse.error instanceof ErrorEvent) {
            // handle client-side error
            message = this.NETWORK_ERROR;
            return throwError(() => { return { status: HttpStatusCode.NetworkAuthenticationRequired, message: this.NETWORK_ERROR }; });
          } else {
            // handle server-side error
            switch (httpErrorResponse.status) {
              case 0: // unknown error, unable connect to server
                return throwError(() => { return { status: 0, message: this.UNKNOWN_ERROR }; });
              case HttpStatusCode.Unauthorized:
                this.usersService.logout();
                this.router.navigate([`/${APP_ROUTES.HOME}`]).then(() => {
                  this.utilsService.showError('Please login then continue!');
                });
                return throwError(() => { return httpErrorResponse; });
              default:
                return throwError(() => httpErrorResponse);
            }
          }
        })
      );
  }
}
